export default __webpack_public_path__ + "static/media/schedule-refresh--white.1a5f7436.svg";